import initializeItemReadingPaneViewState from '../actions/initializeItemReadingPaneViewState';
import { getReadingPaneStore } from '../store/Store';
import ItemReadingPaneViewState from '../store/schema/ItemReadingPaneViewState';
import { mutator } from 'satcheljs';

interface InitializeItemReadingPaneViewStateActionMessage {
    viewState: ItemReadingPaneViewState;
    isPreview: boolean;
}

export default mutator(
    initializeItemReadingPaneViewState,
    function initializeItemReadingPaneViewStateMutator(
        actionMessage: InitializeItemReadingPaneViewStateActionMessage
    ) {
        const { viewState, isPreview } = actionMessage;
        const readingPaneStore = getReadingPaneStore();

        // Update the reading-pane-store with the view state for the readingPane.
        // When inPreview mode we set the itemPreviewViewState to hold the current reading pane view state.
        // This would allow for the regular reading pane view state to be preserved in itemReadingPaneViewState and we can
        // have a preview pane open along side.
        if (isPreview) {
            readingPaneStore.itemPreviewViewState = viewState;
        } else {
            readingPaneStore.itemReadingPaneViewState = viewState;
        }
    }
);
